import type { PropertyFeatureConfig } from '../../../types/insurances/PropertyFeatureConfig';

export const property: PropertyFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
            showPackage: false,
            showContractHolder: true,
            showContractNumber: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        propertySubjects: {
            showSimplifiedAddress: true,
        },
        showLinkedLoans: false,
    },
    history: {
        visible: false,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
